import React from "react";
import styled from "styled-components";
import { propStyling, tombac } from "../../shared";
import { textStyles } from "../../shared/textStyles";

/**
 * @deprecated Use `Menu.Root` instead.
 */
export const Menu = styled.ul.withConfig({
  displayName: "LegacyMenu__Menu"
})(["all:initial;background-color:", ";border-radius:", ";box-shadow:", " ", ";display:flex;flex-flow:column;padding:", ";", ""], tombac.color.white, tombac.unit(5), tombac.unit(0, 1, 3, 0), tombac.alpha("neutral", 16), tombac.space(1, 0), propStyling);

/**
 * @deprecated Use `Menu.Item` instead.
 */
export const MenuItem = styled.li.withConfig({
  displayName: "LegacyMenu__MenuItem"
})(["all:initial;"]);

/**
 * @deprecated Use `Menu.Item` instead.
 */

/**
 * @deprecated Use `Menu.Item` instead.
 */
export const MenuAction = styled.button.attrs(_ref => {
  let {
    children,
    prepend
  } = _ref;
  return {
    children: prepend ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Prepend, null, prepend), children) : children
  };
}).withConfig({
  displayName: "LegacyMenu__MenuAction"
})(["all:initial;align-items:center;box-sizing:border-box;cursor:pointer;display:flex;min-height:", ";padding:", ";transition:background-color 0.1s ease-out;width:100%;", " ", " &:hover{background-color:", ";}&:active{background-color:", ";}"], tombac.space(4), tombac.space(0.5, 2), tombac.altText({
  fontSize: 12,
  fontWeight: "bold"
}), textStyles, tombac.color("neutral", 300), tombac.color("neutral", 400));
const Prepend = styled.span.withConfig({
  displayName: "LegacyMenu__Prepend"
})(["all:initial;margin-right:", ";min-width:", ";text-align:center;"], tombac.space(1), tombac.space(3));
//# sourceMappingURL=LegacyMenu.js.map